import MasterSuppliers from "../../../../pages/Masters/Suppliers/MasterSuppliers";
import MasterSuppliersNewEdit from "../../../../pages/Masters/Suppliers/MasterSuppliers/NewEdit";
import MasterSuppliersDetail from "../../../../pages/Masters/Suppliers/MasterSuppliers/Detail";
import MasterSuppliersTransport from "../../../../pages/Masters/Suppliers/MasterSuppliers/TransportNewEdit";

const routerSuppliers = [
    {
        key: "suppliers",
        path: "/masters/providers",
        element: <MasterSuppliers />,
    },
    {
        key: "suppliers",
        path: "/masters/providers/new",
        element: <MasterSuppliersNewEdit />,
    },
    {
        key: "suppliers",
        path: "/masters/providers/:id",
        element: <MasterSuppliersDetail />,
    },
    {
        key: "suppliers",
        path: "/masters/providers/:id/transport/new",
        element: <MasterSuppliersTransport />,
    },
    {
        key: "suppliers",
        path: "/masters/providers/:id/transport/:transportid",
        element: <MasterSuppliersTransport />,
    }
]

export default routerSuppliers
